import { ILiheContent } from "@/model/Content/LiheContent"
import hasAccomodations, { IHasAccomodations } from "./mixins/Accomodation/hasAccomodations"
import { IGlobalService } from "@/model/Service/GlobalService"
import { IGlobalInsurance } from "@/model/Insurance/GlobalInsurance"
import liheContentResponse from "@/state/liheContentResponse"
import bookingQuoteResponse from "@/state/bookingQuoteResponse"
import { PrestationContent } from "../../../requests-module"


class LiheBase {
    protected content: ILiheContent | null = null
    protected startDate: string | null = null
    protected endDate: string | null = null
    protected globalServicesArr: IGlobalService[] = []
    protected globalServicesMap: Map<string, IGlobalService> = new Map()
    protected globalServicesSelectedArr: IGlobalService[] = []
    protected globalServicesSelectedMap: Map<string, IGlobalService> = new Map()
    protected globalInsurancesArr: IGlobalInsurance[] = []
    protected globalInsurancesMap: Map<string, IGlobalInsurance> = new Map()
    protected globalInsurancesSelectedArr: IGlobalInsurance[] = []
    protected globalInsurancesSelectedMap: Map<string, IGlobalInsurance> = new Map()

    // constructor() {
    // }

    public getContent(): ILiheContent | null {
        return this.content
    }
    public setContent(content: ILiheContent): void {
        this.content = content
    }

    public setStartDate(startDate: string): void {
        this.startDate = startDate
    }
    public getStartDate(): string | null {
        return this.startDate
    }
    public setEndDate(endDate: string): void {
        this.endDate = endDate
    }
    public getEndDate(): string | null {
        return this.endDate
    }

    public getGlobalServicesArr(): IGlobalService[] {
        return this.globalServicesArr
    }
    public getGlobalServicesMap(): Map<string, IGlobalService> {
        return this.globalServicesMap
    }
    public getGlobalServicesSelectedArr(): IGlobalService[] {
        return this.globalServicesArr
    }
    public getGlobalServicesSelectedMap(): Map<string, IGlobalService> {
        return this.globalServicesMap
    }

    public addGlobalService(service: IGlobalService): void {
        if (this.globalServicesMap.has(service.getIdFull())) return
        this.globalServicesArr.push(service)
        this.globalServicesMap.set(service.getIdFull(), service)
    }
    public removeGlobalService(service: IGlobalService): void {
        if (!this.globalServicesMap.has(service.getIdFull())) return
        this.globalServicesArr.filter((existingService: IGlobalService) => existingService.getIdFull() !== service.getIdFull())
        this.globalServicesMap.delete(service.getIdFull())
    }
    public addGlobalServiceSelected(service: IGlobalService): void {
        if (this.globalServicesSelectedMap.has(service.getIdFull())) return
        this.globalServicesSelectedArr.push(service)
        this.globalServicesSelectedMap.set(service.getIdFull(), service)
    }
    public removeGlobalServiceSelected(service: IGlobalService): void {
        if (!this.globalServicesSelectedMap.has(service.getIdFull())) return
        this.globalServicesSelectedArr.filter((existingService: IGlobalService) => existingService.getIdFull() !== service.getIdFull())
        this.globalServicesSelectedMap.delete(service.getIdFull())
    }

    public getGlobalInsurancesArr(): IGlobalInsurance[] {
        return this.globalInsurancesArr
    }
    public getGlobalInsurancesMap(): Map<string, IGlobalInsurance> {
        return this.globalInsurancesMap
    }
    public getGlobalInsurancesSelectedArr(): IGlobalInsurance[] {
        return this.globalInsurancesArr
    }
    public getGlobalInsurancesSelectedMap(): Map<string, IGlobalInsurance> {
        return this.globalInsurancesMap
    }

    public addGlobalInsurance(service: IGlobalInsurance): void {
        if (this.globalInsurancesMap.has(service.getIdFull())) return
        this.globalInsurancesArr.push(service)
        this.globalInsurancesMap.set(service.getIdFull(), service)
    }
    public removeGlobalInsurance(service: IGlobalInsurance): void {
        if (!this.globalInsurancesMap.has(service.getIdFull())) return
        this.globalInsurancesArr.filter((existingInsurance: IGlobalInsurance) => existingInsurance.getIdFull() !== service.getIdFull())
        this.globalInsurancesMap.delete(service.getIdFull())
    }
    public addGlobalInsuranceSelected(service: IGlobalInsurance): void {
        if (this.globalInsurancesSelectedMap.has(service.getIdFull())) return
        this.globalInsurancesSelectedArr.push(service)
        this.globalInsurancesSelectedMap.set(service.getIdFull(), service)
    }
    public removeGlobalInsuranceSelected(service: IGlobalInsurance): void {
        if (!this.globalInsurancesSelectedMap.has(service.getIdFull())) return
        this.globalInsurancesSelectedArr.filter((existingInsurance: IGlobalInsurance) => existingInsurance.getIdFull() !== service.getIdFull())
        this.globalInsurancesSelectedMap.delete(service.getIdFull())
    }

    public getIsPackage(): boolean {
        const packageId = bookingQuoteResponse.value?.state.packageId
        return !!liheContentResponse.value?.prestations.find((prestObj: PrestationContent) => {
            return prestObj.id === packageId
        })
    }
    public getIsHaveSmileAndPass(): boolean {
        return this.getContent()?.getIsHaveCriteria("700") || false
    }

    public getIsHaveD45Cancellation(): boolean {
        return this.getContent()?.getIsHaveCriteria("977") || this.getContent()?.getIsHaveCriteria("976") || false
    }
}


export interface ILihe extends LiheBase, IHasAccomodations {
    setContent(content: ILiheContent): void
    getContent(): ILiheContent | null
    setStartDate(startDate: string): void
    getStartDate(): string | null
    setEndDate(endDate: string): void
    getEndDate(): string | null
    getGlobalServicesArr(): IGlobalService[]
    getGlobalServicesMap(): Map<string, IGlobalService>
    addGlobalService(service: IGlobalService): void
    removeGlobalService(service: IGlobalService): void
    getGlobalInsurancesArr(): IGlobalInsurance[]
    getGlobalInsurancesMap(): Map<string, IGlobalInsurance>
    addGlobalInsurance(service: IGlobalInsurance): void
    removeGlobalInsurance(service: IGlobalInsurance): void
}

// apply mixins
const Lihe: Constructor<ILihe> = hasAccomodations(LiheBase)

export default Lihe